import { mapGetters, mapState } from 'vuex'

export default {
    data() {
        return {

        }
    },

    mounted() {
        this.configurator = document.getElementById('configurator')
        this.body = document.getElementById('orders')
        this.attachHeaderEvents()
    },

    methods: {
        attachHeaderEvents() {
            window.addEventListener('scroll', () => {
                if (this.configurator.getBoundingClientRect().top < this.ofssetTop()) {
                    this.$refs.ordersSummary.classList.add('orders-summary-fixed')
                } else {
                    this.$refs.ordersSummary.classList.remove('orders-summary-fixed')
                }
            })
        },

        ofssetTop() {
            return this.body.getBoundingClientRect().width < 992 ? 50 : 0
        }
    },

    computed: {

        ...mapState('products',{
            currentKey: state => state.selection.currentKey
        }),

        ...mapGetters('products', {
            formattedPrice: 'getFormattedPrice',
        }),
    }
}
